import script from "./HeadForm.vue?vue&type=script&setup=true&lang=js"
export * from "./HeadForm.vue?vue&type=script&setup=true&lang=js"

import "./HeadForm.vue?vue&type=style&index=0&id=c33f7562&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c33f7562"]])

export default __exports__